import { H3 } from '../../../../components/Basic/WrapsStyle';
import HistoryBase from './Base';
// import styles from './styles.module.scss';

const HistoryPostingBlock = ({ history = [], save = (_) => _ }) => {
  return (
    <>
      <H3 style={{ marginBottom: '10px' }}>История заказа</H3>
      <table>
        <thead>
          <tr>
            <th style={{ width: '150px' }}>Время</th>

            <th style={{ width: '250px' }}>Инициатор</th>
            <th style={{ width: '550px' }}>Событие</th>
          </tr>
        </thead>
        <tbody>
          {history
            .sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime())
            .map((item) => (
              <tr key={item['_id']}>
                <HistoryBase part={item} />
              </tr>
            ))}
        </tbody>
      </table>
    </>
  );
};

export default HistoryPostingBlock;
